const STATUS_STYLE_MAP = {
  payment_due: "bg-[#FFFAEB] text-[#B54708] ring-[#FEC84B]",
  pending: "bg-[#FFF7ED] text-[#B54708] ring-[#FEC84B]",
  confirmed: "bg-[#EFF8FF] text-[#175CD3] ring-[#B2DDFF]",
  ready_for_pickup: "bg-[#EEF4FF] text-[#3538CD] ring-[#C7D7FE]",
  packed: "bg-[#E0EAFF] text-[#1D4ED8] ring-[#BFDBFE]",
  picked: "bg-[#F0F9FF] text-[#0369A1] ring-[#BAE6FD]",
  delivered: "bg-[#ECFDF3] text-[#067647] ring-[#ABEFC6]",
  delivered_offline: "bg-[#ECFDF3] text-[#067647] ring-[#ABEFC6]",
  undelivered: "bg-[#FEF3F2] text-[#B42318] ring-[#FDA29B]",
  assign_delivery: "bg-[#F3F4F6] text-[#374151] ring-[#D1D5DB]",
  cancelled: "bg-[#FEF3F2] text-[#B42318] ring-[#FDA29B]",
  return_initiated: "bg-[#FFF4ED] text-[#C4320A] ring-[#FFDAC2]",
  return_in_transit: "bg-[#FFF4ED] text-[#C4320A] ring-[#FFDAC2]",
  undelivered_in_transit: "bg-[#FFF4ED] text-[#C4320A] ring-[#FFDAC2]",
  returned: "bg-[#F5F3FF] text-[#5925DC] ring-[#D9D6FE]",
  partially_returned: "bg-[#F5F3FF] text-[#5925DC] ring-[#D9D6FE]",
};

const STATUS_LABEL_MAP = {
  undelivered_in_transit: "Reverse In Transit",
  return_in_transit: "Reverse In Transit",
};

const formatStatusLabel = (value: string) =>
  value
    ?.split("_")
    ?.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
    ?.join(" ");

const OrderStatus = ({ status }) => {
  if (!status) return null;

  const statusClass = STATUS_STYLE_MAP[status] || "bg-[#F3F4F6] text-[#111827] ring-[#D1D5DB]";
  const displayLabel = STATUS_LABEL_MAP[status] || formatStatusLabel(status);

  return (
    <span
      className={`inline-flex text-xs items-center rounded-full px-2.5 py-1 text-[11px] font-semibold ring-1 ring-inset whitespace-nowrap ${statusClass}`}
    >
      {displayLabel}
    </span>
  );
};

export default OrderStatus;
